import { render } from "./BatchSendModal.vue?vue&type=template&id=37fe919a&scoped=true"
import script from "./BatchSendModal.vue?vue&type=script&lang=js"
export * from "./BatchSendModal.vue?vue&type=script&lang=js"

import "./BatchSendModal.vue?vue&type=style&index=0&id=37fe919a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37fe919a"]])

export default __exports__